export const isScrollLocked = () => {
  if (typeof document !== 'undefined') {
    return document.body.style.overflow === 'hidden';
  }
};

export const isScrollUnLocked = () => {
  if (typeof document !== 'undefined') {
    return !isScrollLocked();
  }
};

export const scrollLock = () => {
  if (typeof document !== 'undefined') {
    document.body.style.overflow = 'hidden';
  }
};

export const scrollUnlock = () => {
  if (typeof document !== 'undefined') {
    document.body.style.overflow = 'auto';
  }
};
